<div style="display:grid;place-items:center;height:100vh;text-align:center;">
    <div *ngIf="user else loggedOut">
        <h1>
            {{ isLoading ? 'Authorizing' : (isError ? 'Error' : 'Successfully authenticated!') }}
        </h1>
        <p>{{ 
        isLoading ? 'If this process takes more than a coupe of seconds please close the window and try again' : (
            isError ? errorMessage : 'The app has been authorized, you can now close this window.'
        )
        }}</p>
    </div>
    <ng-template #loggedOut>
        <div>
            <h1 style="margin-bottom: 20px;">Sign in as an admin to authorize this app</h1>
            <button *ngIf="!user" class="button regular solid-green" (click)="login()">Login</button>
        </div>
    </ng-template>
</div>
